import React from 'react';
import { compose } from 'recompose';
import { AccountPage } from '../../../templates/account';
import { withBarrier } from '../../barrier';
import { ConfigService } from '../../../services/config-service';
import { ConsentLists } from '../components/consent-list';

const Component = () => {
  const { title, identifier, subheading, inPageMessage, message, heading, body, fields, pageHeader } =
    ConfigService.get('ACCOUNT.MAIN.pages.cookies', {});

  return (
    <AccountPage
      title={title}
      subheading={subheading}
      category={identifier}
      inPageMessage={inPageMessage}
      message={message}
      heading={heading}
      body={body}
      pageHeader={pageHeader}
    >
      <ConsentLists title={fields} />
    </AccountPage>
  );
};

export const AccountCookies = compose(withBarrier)(Component);
